<template>
  <div class="door-title">
    <img src="./img/DIYtitleFont.png" v-if="styleType=='typeDark'" />
    <img src="./img/DIYtitleFont_green.png" v-else-if="styleType=='typeGreen'" />
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "doorTitle",
  data() {
    //这里存放数据
    return {
      styleType: "",
    };
  },
  computed: {
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
  },
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
        this.componentTiny = this.$store.state.componentTiny;
      },
      deep: true,
    },
  },
  created() {
    this.styleType = this.$store.state.styleType;
  },
};
</script>
<style lang="scss" scoped>
.door-title {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  height: 20px;
  font-size: 20px;
  font-weight: 500;
  color: #e2effd;
  line-height: 20px;

  img {
    margin:0px 10px;
    // width: 2px;
    // height: 20px;
  }
}
</style>